/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { ScorecardSectionResult } from './ScorecardSectionResult.js';
import {
    ScorecardSectionResultFromJSON,
    ScorecardSectionResultFromJSONTyped,
    ScorecardSectionResultToJSON,
} from './ScorecardSectionResult.js';
import type { SectionSummaryEntity } from './SectionSummaryEntity.js';
import {
    SectionSummaryEntityFromJSON,
    SectionSummaryEntityFromJSONTyped,
    SectionSummaryEntityToJSON,
} from './SectionSummaryEntity.js';

/**
 * 
 * @export
 * @interface ScorecardSectionWithResult
 */
export interface ScorecardSectionWithResult {
    /**
     * 
     * @type {SectionSummaryEntity}
     * @memberof ScorecardSectionWithResult
     */
    section?: SectionSummaryEntity;
    /**
     * 
     * @type {ScorecardSectionResult}
     * @memberof ScorecardSectionWithResult
     */
    result?: ScorecardSectionResult;
}

/**
 * Check if a given object implements the ScorecardSectionWithResult interface.
 */
export function instanceOfScorecardSectionWithResult(value: object): boolean {
    return true;
}

export function ScorecardSectionWithResultFromJSON(json: any): ScorecardSectionWithResult {
    return ScorecardSectionWithResultFromJSONTyped(json, false);
}

export function ScorecardSectionWithResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): ScorecardSectionWithResult {
    if (json == null) {
        return json;
    }
    return {
        
        'section': json['section'] == null ? undefined : SectionSummaryEntityFromJSON(json['section']),
        'result': json['result'] == null ? undefined : ScorecardSectionResultFromJSON(json['result']),
    };
}

export function ScorecardSectionWithResultToJSON(value?: ScorecardSectionWithResult | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'section': SectionSummaryEntityToJSON(value['section']),
        'result': ScorecardSectionResultToJSON(value['result']),
    };
}

